<template>
  <div class="chat-authorize" v-if="page.vis">
    <div class="chat-authorize__panel" @click.stop="(e) => {}">
      <div class="chat-authorize__panel-body">
        <div class="chat-authorize__title">欢迎咨询</div>
        <div class="chat-authorize__tooltip">完成相关授权，立即体验在线客服服务</div>
        <el-form ref="formRef" :model="page.form" :rules="page.rules" label-width="0">
          <el-form-item prop="name">
            <el-input v-model="page.form.name" placeholder="请输入您的姓名" />
          </el-form-item>
          <el-form-item prop="mobile">
            <el-input v-model="page.form.mobile" placeholder="请输入您的手机号">
              <template #append>
                <div @click="handleSend">
                  {{ page.sendText === '获取验证码' ? page.sendText : `${page.sendText}s` }}
                </div>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="authcode">
            <el-input v-model="page.form.authcode" placeholder="请输入验证码" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" class="flex-1" @click="handleSubmit">立即使用</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script setup>
import { reactive, defineExpose, defineEmits, ref, getCurrentInstance, onBeforeUnmount } from 'vue'
import { ElMessage } from 'element-plus'
const emit = defineEmits(['init'])
const validateMobile = (rule, value, callback) => {
  if (!value || value === '') {
    callback('电话号码不能为空')
  } else {
    let reg = /^1[3-9]\d{9}$/
    if (!reg.test(value)) {
      callback('请输入正确的电话号码')
    } else {
      callback()
    }
  }
}
const { proxy } = getCurrentInstance()
const page = reactive({
  vis: false,
  form: {
    name: '',
    mobile: '',
    authcode: ''
  },
  rules: {
    name: { required: true, message: '姓名不能为空', trigger: 'blur' },
    mobile: [
      { required: true, message: '电话号码不能为空', trigger: 'blur' },
      { validator: validateMobile, trigger: 'blur' }
    ],
    authcode: { required: true, message: '验证码不能为空', trigger: 'blur' }
  },
  sendText: '获取验证码'
})
const open = () => {
  page.vis = true
}
const close = () => {
  page.vis = false
  page.form = {}
}
const formRef = ref(null)
const handleSubmit = () => {
  formRef.value.validate(async (valid) => {
    if (valid) {
      // 校验验证码
      let params = { code: page.form.authcode, mobile: page.form.mobile }
      let res = await proxy.$http.post('/sms/checkCode', params)
      if (res.code === 0) {
        emit('init', page.form)
        close()
      } else {
        ElMessage.error(res.msg)
      }
    }
  })
}
let timer
const handleSend = async () => {
  if (page.sendText === '获取验证码') {
    if (!page.form.mobile || page.form.mobile === '') {
      return ElMessage.error('请输入您的手机号')
    }
    if (!/^1[3-9]\d{9}$/.test(page.form.mobile)) {
      return ElMessage.error('请输入正确的电话号码')
    }
    // 发送验证码
    let res = await proxy.$http.post('/sms/sendCode', { mobile: page.form.mobile })
    if (res.code === 0) {
      startTimer()
    } else {
      ElMessage.error(res.msg)
    }
  }
}
const clearTimer = () => {
  clearInterval(timer)
  timer = null
}
const startTimer = () => {
  page.sendText = 60
  clearTimer()
  timer = setInterval(() => {
    page.sendText -= 1
    if (page.sendText <= 0) {
      clearTimer()
      page.sendText = '获取验证码'
    }
  }, 1000)
}
onBeforeUnmount(() => {
  clearTimer()
})
defineExpose({
  open
})
</script>
<style lang="less" scoped>
.chat-authorize {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  &__header-icon {
    color: #999999;
    cursor: pointer;
  }
  &__panel {
    background-color: #ffffff;
    border-radius: 10px;
    width: 300px;
  }
  &__title {
    font-weight: 600;
    font-size: 16px;
    color: #444444;
  }
  &__tooltip {
    font-size: 12px;
    color: #666666;
    line-height: 3;
    > span {
      color: #409eff;
    }
  }
  &__panel-header {
    padding: 10px;
    line-height: 62px;
  }
  &__panel-body {
    padding: 10px;
    :deep(.el-checkbox) {
      margin-right: 6px;
    }
    :deep(.el-input-group__append) {
      background-color: unset;
      font-size: 12px;
      padding: 0 12px;
      color: #409eff;
      box-shadow: unset;
      border-bottom: 1px solid #eeeeee;
      text-align: center;
      cursor: pointer;
    }
    :deep(.el-input__wrapper) {
      box-shadow: unset;
      border-bottom: 1px solid #eeeeee;
      font-size: 12px;
    }
  }
}
</style>
